var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: "66.25px",
    height: "41.5px",
    viewBox: "0 0 66.25 41.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L9.19132 0L9.19132 29.7917L0 29.7917L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 29.5035L56 29.4965",
    id: "Stroke-1",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#394553",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7157 38.8876C23.6284 39.1131 21.2469 39.2508 19.7338 36.7004L13.3408 25.7895L9.46224 25.7895",
    id: "Stroke-2",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#394553",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9598 27.5855L34.7874 34.4471",
    id: "Stroke-4",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4226 32.0688L27.9068 36.365",
    id: "Stroke-6",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7284 36.0077C38.6135 36.4766 36.481 37.3539 34.7627 34.4217",
    id: "Stroke-8",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#394553",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9405 37.8452C31.9405 37.8452 29.6071 39.4428 27.9102 36.364",
    id: "Stroke-10",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#394553",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44582 3.63354L22.0642 3.63354",
    id: "Stroke-12",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#394553",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0678406 0L9.19061 0L9.19061 29.7917L0 29.7917",
    id: "Stroke-14",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#394553",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(55.808678 2.5651844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L9.19132 0L9.19132 29.7917L0 29.7917L0 0Z",
    id: "Clip-17",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.12366 0L0 0L0 29.7917L9.1915 29.7917",
    id: "Stroke-16",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#394553",
    strokeWidth: 4.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M48.8448 30.5512L38.5277 10.9902C37.6529 10.9343 33.2067 10.5365 33.2067 10.5365L27.1144 16.6921C22.03 20.5576 19.2503 14.8593 19.2503 14.8593L27.077 4.71025C29.7013 1.42907 32.3426 1.39177 32.3426 1.39177L44.1237 1.40864L55.661 6.40191",
    id: "Stroke-19",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#D08E01",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5221 29.7708C49.0543 31.0868 46.0533 38.784 42.1783 32.0441L36.7815 23.6231",
    id: "Stroke-21",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6945 24.9302C63.6945 25.3138 63.3839 25.6219 62.9991 25.6219C62.6153 25.6219 62.3029 25.3138 62.3029 24.9302C62.3029 24.5465 62.6153 24.2384 62.9991 24.2384C63.3839 24.2384 63.6945 24.5465 63.6945 24.9302",
    id: "Fill-23",
    fill: "#394553",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6945 24.9302C63.6945 25.3138 63.3839 25.6219 62.9991 25.6219C62.6153 25.6219 62.3029 25.3138 62.3029 24.9302C62.3029 24.5465 62.6153 24.2384 62.9991 24.2384C63.3839 24.2384 63.6945 24.5465 63.6945 24.9302Z",
    id: "Stroke-25",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#394553",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67604 22.2765C2.67604 22.6602 2.3663 22.9683 1.98157 22.9683C1.59773 22.9683 1.28531 22.6602 1.28531 22.2765C1.28531 21.8929 1.59773 21.5848 1.98157 21.5848C2.3663 21.5848 2.67604 21.8929 2.67604 22.2765",
    id: "Fill-27",
    fill: "#394553",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67604 22.2765C2.67604 22.6602 2.3663 22.9683 1.98157 22.9683C1.59773 22.9683 1.28531 22.6602 1.28531 22.2765C1.28531 21.8929 1.59773 21.5848 1.98157 21.5848C2.3663 21.5848 2.67604 21.8929 2.67604 22.2765Z",
    id: "Stroke-29",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#394553",
    strokeWidth: 2.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProf);
export default __webpack_public_path__ + "static/media/prof.0853d831855ce5b2db6607c1b8e0a553.svg";
export { ForwardRef as ReactComponent };